import React from 'react'
import mod from './Layout.module.css'

function ErrorMessage(props) {
  return (
    <div className={mod.errorMessage}>{props.message}</div>
  )
}

export default ErrorMessage